import { styled } from '@mui/material'
import {
  AggregateFieldToggleGroup,
  AggregateTargetToggleGroup,
  WorkloadUnitToggleGroup,
} from '../../../../components/toggleGroups'
import DisplayFormatButton from '../../../../containers/BulkSheetView/components/header/DisplayFormatButton'
import ColumnSettingButton from '../../../../containers/BulkSheetView/components/header/ColumnSettingButton'

import {
  AggregateField,
  AggregateTarget,
} from '../../../../../domain/entity/WbsItemEntity'
import { WorkloadUnit } from '../../../../../lib/functions/workload'

type Props = {
  editable: boolean
  onChangeAggregateTarget: (value: AggregateTarget) => void
  aggregateTarget: AggregateTarget
  /** 集計対象トグルを出すか。省略時は出す */
  showAggregateTarget?: boolean
  onChangeAggregateField: (value: AggregateField) => void
  aggregateField: AggregateField
  onChangeWorkloadUnit: (_: WorkloadUnit) => void
  workloadUnit: WorkloadUnit
  rowHeight: number | undefined
  onChangeHeight: (value: number) => void
  onClickColumnSettingButton: (e: React.MouseEvent<HTMLButtonElement>) => void
  columnSettingOpen: boolean
}

const ProgressReportGridWbsHeader = ({
  editable,
  aggregateTarget,
  onChangeAggregateTarget,
  showAggregateTarget = true,
  onChangeAggregateField,
  aggregateField,
  onChangeWorkloadUnit,
  workloadUnit,
  rowHeight,
  onChangeHeight,
  onClickColumnSettingButton,
  columnSettingOpen,
}: Props) => {
  return (
    <HeaderArea>
      {showAggregateTarget && (
        <AggregateTargetToggleGroup
          value={aggregateTarget}
          onChange={onChangeAggregateTarget}
        />
      )}
      <AggregateFieldToggleGroup
        value={aggregateField}
        onChange={onChangeAggregateField}
      />
      <WorkloadUnitToggleGroup
        value={workloadUnit}
        refresh={onChangeWorkloadUnit}
        disabled={aggregateField !== AggregateField.WBS_ITEM_WORKLOAD}
      />
      {editable && (
        <>
          <ColumnSettingButton
            onClick={onClickColumnSettingButton}
            open={columnSettingOpen}
          />
          <DisplayFormatButton
            height={rowHeight}
            onChangeHeight={onChangeHeight}
          />
        </>
      )}
    </HeaderArea>
  )
}

const HeaderArea = styled('div')({
  display: 'flex',
  alignItems: 'center',
  margin: '10px 10px 5px 10px',
  overflowX: 'auto',
  overflowY: 'hidden',
  minHeight: '47px',
  gap: '10px',
})

export default ProgressReportGridWbsHeader
